import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HealthClient} from '../../../api/api-client';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {SubscriptionManager} from '../../../services/subscription-manager.service';

@Component({
  selector: 'app-settings',
  imports: [CommonModule, FormsModule,ToggleButtonModule],
  providers:[SubscriptionManager],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent implements OnInit {
  frontendVersion: string = environment.version;
  backendVersion!: string;
  isDarkMode: boolean = false;

  constructor(
    private readonly subscriptionManager:SubscriptionManager,
    private readonly healthClient: HealthClient
  ) {}

  ngOnInit(): void {
    this.subscriptionManager.call(
    this.healthClient.health(),
      (x => {
      this.backendVersion = x.result.version ?? "";
    })
    );

    this.initializeDarkMode();
  }

  private initializeDarkMode() {
    const html = document.documentElement;

    const savedMode = localStorage.getItem('theme');
    const prefersDark = globalThis.matchMedia('(prefers-color-scheme: dark)').matches;

    if (savedMode === 'dark' || (!savedMode && prefersDark)) {
      this.isDarkMode = true;
      html.classList.add('dark');
    } else {
      this.isDarkMode = false;
      html.classList.remove('dark');
    }
  }

  protected toggleDarkMode() {
    const html = document.documentElement;
    if (this.isDarkMode) {
      html.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      html.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }
}
